import { render, staticRenderFns } from "./ManualSend.vue?vue&type=template&id=1bb98252&scoped=true&"
import script from "./ManualSend.vue?vue&type=script&lang=js&"
export * from "./ManualSend.vue?vue&type=script&lang=js&"
import style0 from "./ManualSend.vue?vue&type=style&index=0&id=1bb98252&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb98252",
  null
  
)

export default component.exports